import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { Home } from '../Home';
import { Login } from '../Login';
import { NavBar } from '../NavBar';
import { SendEmailLink } from '../SendEmailLink';
import firebase from '../firebase';
import { useAppDispatch } from './AppContext';
import { ImageLoader } from '../ImageLoader';
import { Inventory } from '../Inventory';
import { BookDetails } from '../BookDetails/component';

export const Component = () => {
  const dispatch = useAppDispatch();

  firebase.auth().onAuthStateChanged(function (user) {
    if (user) {
      dispatch({
        type: 'SET_USER',
        user: { email: user.email, name: user.displayName },
      });
    } else {
      dispatch({ type: 'SET_USER', user: undefined });
    }
  });

  return (
    <Router>
      <NavBar />
      <Switch>
        <Route path="/book/:id">
          <BookDetails />
        </Route>
        <Route path="/gallery">
          <ImageLoader />
        </Route>
        <Route path="/inventory">
          <Inventory />
        </Route>
        <Route path="/elink">
          <SendEmailLink />
        </Route>
        <Route path="/login">
          <Login />
        </Route>
        <Route path="/">
          <Home />
        </Route>
      </Switch>
    </Router>
  );
};
